import React from "react";
import { UpsellCTASection } from "get-life-storybook-ts";
import { TagFormat } from "get-life-storybook-ts/lib/molecules/RenderTags/RenderTags";
import { ChipI } from "get-life-storybook-ts/lib/atoms/Chip/Chip";

interface PriceData {
  price: string;
  priceLabel: string;
  decimals: string;
  frequency?: string;
  after?: string;
  PromoOnClick?: () => void;
}

interface UpsellCTAProps {
  translate: (key: string) => string;
  isMobile: boolean;
  isABtesting: boolean;
  chipsData: ChipI[];
  priceData: PriceData;
  selectPlan: () => void;
  handleCallMe: () => void;
  renderPriceValidation: () => string;
  loading?: boolean;
}

const UpsellCTA: React.FC<UpsellCTAProps> = ({
  translate,
  isMobile,
  isABtesting,
  chipsData,
  priceData,
  selectPlan,
  handleCallMe,
  renderPriceValidation,
  loading = false,
}) => {
  const handleSelectPlan = () => {
    if (loading) return;
    selectPlan();
  };
  return (
    <div
      className="payment-newUpsellContainer__newsection-upsellCTA"
      id="upsell_page_upsell_cta"
    >
      <UpsellCTASection
        buttonTextCustomPolicy={translate(
          "aggregator.personalInformation.btnContract"
        )}
        onClick={() => handleCallMe()}
        onClickCP={() => handleSelectPlan()}
        subtitlePB={isABtesting ? renderPriceValidation() : undefined}
        paragraph1CTA={translate("newUpsell.ctaSection.paragraph1CTA")}
        paragraph2CTA={translate("newUpsell.ctaSection.paragraph2CTA")}
        phone={process.env.REACT_APP_TEL!}
        tags={chipsData as unknown as TagFormat[]}
        textButton={translate("newUpsell.ctaSection.textButton")}
        title2CTA={translate("newUpsell.ctaSection.title2CTA")}
        titleCTA={translate("newUpsell.ctaSection.titleCTA")}
        titlePrice={
          isMobile
            ? translate("newUpsell.ctaSection.titlePrice")
            : translate("newUpsell.resumeCart.titlePrice")
        }
        showCustomText={true}
        customText={translate("newUpsell.resumeCart.titleCP")}
        onClickCustomText={() =>
          window.scrollTo({ top: 500, left: 0, behavior: "smooth" })
        }
        tooltipIcon="BulbIcon"
        tooltipText={
          isABtesting ? (
            <span
              className="payment-newUpsellContainer__newsection--tooltip"
              dangerouslySetInnerHTML={{
                __html: translate("newUpsell.resumeCart.tooltipValidDate"),
              }}
            />
          ) : undefined
        }
        price={priceData}
        trustpilot={translate("newUpsell.ctaSection.trustpilot")}
      />
    </div>
  );
};

export default UpsellCTA;
